import './_product-delivery-checker.scss';
import component from './product-delivery-checker';

export default component;
